import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import ThreadOrderSelect from '../ThreadOrderSelect';
import s from './ThreadHeader.scss';
var ThreadHeader = function (_a) {
    var total = _a.total, commentableTypeId = _a.commentableTypeId, commentableItemId = _a.commentableItemId, parentId = _a.parentId, _b = _a.withOrder, withOrder = _b === void 0 ? true : _b, _c = _a.withTitle, withTitle = _c === void 0 ? true : _c, children = _a.children, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    if (!withOrder && !withTitle) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { className: className, alignItems: "center", dataHook: BiDataHook.COMMENTS_THREAD_STATS },
            React.createElement("div", { "data-hook": BiDataHook.COMMENTS_THREAD_COUNT }, withTitle && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: s['title'] }, t('commentthread.control.comments')),
                total !== undefined && (React.createElement("span", { className: s['total'] }, total))))),
            !isMobile && React.createElement(React.Fragment, null, children),
            withOrder && isLoggedIn && (React.createElement(ThreadOrderSelect, { commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, parentId: parentId }))),
        isMobile && React.createElement(Flex, null, children)));
};
ThreadHeader.displayName = 'ThreadHeader';
export default ThreadHeader;
//# sourceMappingURL=ThreadHeader.js.map